import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/globals.css'
import { logAppVersion } from './utils/version'

// Log app version and deployment info
logAppVersion();

// Note: React.StrictMode disabled in production to prevent double-initialization
// issues with Supabase auth state management and form handling
const isDevelopment = import.meta.env.DEV;

ReactDOM.createRoot(document.getElementById('root')!).render(
  isDevelopment ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
)
